<template>
    <ProviderButton
        id="google"
        :color="props.color"
        :size="props.size"
        providerDisplayName="Google"
        :disabled="pending"
        :onClick="handleClick"
    />
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import { useGoogleAuthStore } from '@/store/google-auth-store'

import ProviderButton from './ProviderButton.vue'

const props = defineProps<{
    color: 'carbon-400' | 'carbon-200'
    size: 's' | 'l'
    onFinish?: (isSuccess: boolean, errorMessage?: string) => void
}>()

const googleAuthStore = useGoogleAuthStore()

const pending = ref(false)

async function handleClick() {
    if (pending.value) {
        return
    }

    pending.value = true

    try {
        if (props.onFinish) {
            googleAuthStore.setOnFinishCallback(props.onFinish)
        }
        await googleAuthStore.requestNativeSignIn()
    } catch (e) {
        props.onFinish?.(false, (e as Error)?.message || String(e))
    } finally {
        pending.value = false
    }
}
</script>
